import { LightButton, DarkButton } from "@/ui/Button"
import { Warning } from "@/ui/icons/Warning"
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalProps, Button, Divider, cn } from "@heroui/react"
import { useTranslations } from "next-intl"
import { ReactNode } from "react"

export const ErrorConfirm = (
  { title, message, isLoading, isConfirmDisabled, onConfirm, cancel,
    confirm, classNames = {}, ...props }:
    Omit<ModalProps, 'children'> &
    {
      onConfirm?: () => void
      message?: ReactNode
      isLoading?: boolean
      isConfirmDisabled?: boolean
      cancel?: (onClose: () => void) => ReactNode
      confirm?: (onClose: () => void) => ReactNode
    }
) => {
  const t = useTranslations()
  return (
    <Modal
      classNames={{
        ...classNames,
        base: cn("max-w-[400px]", classNames.base),
      }}
      {...props}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader
              className="px-[24px] flex justify-between items-center pt-[28px] pb-[4px] text-[20px] text-theme-primary"
            >
              <span>{title}</span>
              <Warning />
            </ModalHeader>
            <ModalBody className="px-[24px] font-[500] leading-[24px] text-theme-primary/70 mt-[4px] text-[16px] max-h-[340px] overflow-y-auto ">
              <Divider className="bg-theme-primary/5" />
              {message}
            </ModalBody>
            <ModalFooter className="px-[24px] pb-[32px] mt-[12px] justify-right gap-[16px]">
              {cancel ? cancel(onClose) : <LightButton className="w-[120px]" onPress={onClose}>{t('common.cancel')}</LightButton>}
              {confirm ? confirm(onClose) : <Button isLoading={isLoading} isDisabled={isConfirmDisabled} className="w-[120px]" color="danger" radius="full" onPress={onConfirm}>{t('common.confirm')}</Button>}
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}